/**
 * Home landing-page endpoints — the shared cached live read and the
 * turn-zero brief (PRD-0271 D-2/D-3). Both routes carry a trailing slash,
 * matching every other facade module, to avoid a FastAPI 307 redirect.
 */

import type { HomeBriefResponse, HomeLiveResponse } from '@/types/home'
import { apiClient } from './client'

export const home = {
  live: async (): Promise<HomeLiveResponse> => {
    const response = await apiClient.get<HomeLiveResponse>('/api/v1/home/live/')
    return response.data
  },

  brief: async (): Promise<HomeBriefResponse> => {
    const response = await apiClient.post<HomeBriefResponse>('/api/v1/home/brief/')
    return response.data
  },
}
